import React, {useEffect, useState} from "react";
import ProfileScreen from "./ProfileScreen";

const ProfileApiClient = () => {
  const [profiles, setProfiles] = useState([]);
  // Retrieve the initial set of tweets and put them into State
  const url = 'https://enigmatic-fortress-23182.herokuapp.com/api/profile';
  useEffect(() =>
      fetch(url)
      .then(response => response.json())
      .then(profiles => setProfiles(profiles)), []);

  return(
      <>
        <ul className="list-group">
          {
            profiles.map(profile =>
                <ProfileScreen profile={profile}/>
            )
          }
        </ul>
      </>
  )
};
export default ProfileApiClient;
